import { useState, useMemo, useCallback,  } from "react";
import { Skeleton, IconButton, Box, } from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import LoadingMoreArticles from '../LoadingMoreArticles.js'
import SmallArticleList from '../ArticleComponents/SmallArticleList.js'
import {carouselPaginationEnabled} from '../utils.js'
// import './ArticleCategory.css'

export default function ArticleCategory(props = {}) {

  const {
    editable,
    ouCornerCategory,
    articles,
    loading,
    loadingMore,
    totalArticlesAvailable,
    moreAvailable,
    loadMoreArticles,
    window,
    loopArticles = true
  } = props

  const moreArticlesAvailable = (totalArticlesAvailable !== undefined && totalArticlesAvailable > articles?.length) || moreAvailable
  const [startIndex, setStartIndex] = useState(0)
  const [isSliding, setIsSliding]   = useState(false);
  const [showLoadingMore, setShowLoadingMore] = useState(false)

  const prevArticle = () => {
    setStartIndex((currentStartIndex) => {
      if (loopArticles) return currentStartIndex - 1
      return Math.max(0, currentStartIndex - 1)
    })
  };

  const WINDOW = window;
  const SLIDE_MS = 450;   
  const maxStartIndex = Math.max(0, (articles?.length || 0) - WINDOW)
  const atStart = startIndex <= 0
  const atEnd = !moreArticlesAvailable && startIndex >= maxStartIndex

  const nextArticle = async () => {
    const nextIndex = startIndex + 1;

    if (!moreArticlesAvailable && nextIndex >= articles?.length) {
      if (loopArticles) setStartIndex(0);
      return;
    }

    if (!loopArticles && atEnd) return;

    const needMore =
      nextIndex + (WINDOW - 1) >= articles.length &&
      moreArticlesAvailable;

    if (needMore) {
      setShowLoadingMore(true)
      await loadMoreArticles()
      setShowLoadingMore(false)
    }

    setStartIndex((currentStartIndex) => {
      if (loopArticles) return currentStartIndex + 1

      const nextStartIndex = currentStartIndex + 1
      const currentMaxStartIndex = Math.max(0, (articles?.length || 0) - WINDOW)
      const adjustedMaxStartIndex = Math.max(currentMaxStartIndex, nextStartIndex)
      return Math.min(adjustedMaxStartIndex, nextStartIndex)
    });
  };

  const visibleArticles = useMemo(() => {
    if (!articles?.length) return [];
    if (articles.length <= WINDOW) return articles

    if (!loopArticles) {
      return articles.slice(startIndex, startIndex + WINDOW)
    }

    const visible = [];
    for (let i = 0; i < WINDOW; i++) {
      const index = ((startIndex + i) % articles.length + articles.length) % articles.length;
      visible.push(articles[index]);
    }

    return visible;
  }, [articles, startIndex, WINDOW, loopArticles]);

  const [calculatedShowPrev, calculatedShowNext] = carouselPaginationEnabled(WINDOW, articles.length, totalArticlesAvailable, moreAvailable, startIndex)
  const showPrev = loopArticles ? calculatedShowPrev : (calculatedShowPrev && !atStart)
  const showNext = loopArticles ? calculatedShowNext : (calculatedShowNext && !atEnd)
    
  return (<>
    {loading || visibleArticles?.length > 0 ? <>
    
      {loading && <Skeleton sx={{margin: '4px !important'}} className="tertiary-article-height article-tile"></Skeleton>}
      {!loading &&
        <SmallArticleList
          editable={editable && !loading}
          ouCorner
          ouCornerCategory={ouCornerCategory}
          published={true}
          articles={visibleArticles}
          loading={loading}
          loadingMore={loadingMore}
          showPrevious={showPrev}
          showNext={showNext}
          onPrevious={prevArticle}
          onNext={nextArticle}
          compact
          tilesPerRow={window}
        />}

    </> : <span>No Articles</span>}
  </>);
}
